module.exports = __webpack_public_path__ + "img/table-arrow.18bcc108.svg";